module.exports = __webpack_public_path__ + "img/14_en.07a862c0.png";